
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32.002 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.64 29.058l-13.876-26A1.997 1.997 0 0016.002 2H16c-.738 0-1.414.406-1.762 1.056L.3 29.056a2.004 2.004 0 00.046 1.972A2.005 2.005 0 002.062 32h27.812a2 2 0 001.766-2.942zM2.062 30L16 4l13.876 26H2.062zM14 14.032v6a2 2 0 004 0v-6a2 2 0 00-4 0zM14 26a2 2 0 104 0 2 2 0 10-4 0z"}})])
          )
        }
      }
    